import { SxProps, Theme } from '@mui/material/styles';
import isNil from 'lodash/isNil';

export const restrictedSxPropertiesError = (sx?: SxProps<Theme>) => {
  if (isNil(sx)) return;

  const items = Array.isArray(sx) ? sx : [sx];
  for (const item of items) {
    if (isNil(item) || typeof item !== 'object' || typeof item === 'function') continue;
    const forbidden = ['color', 'backgroundColor', 'fontSize', 'padding', 'borderRadius'] as const;
    for (const key of forbidden) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
        throw new Error(
          `PIconButton: "${key}" cannot be set via sx. Use the dedicated prop instead or adjust the theme.`,
        );
      }
    }
  }
};
